document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-scope-path="layouts/_header"]')
  const areaOpeners = header.querySelectorAll('.js-area-opener')
  const areaClosers = header.querySelectorAll('.js-area-closer')
  const areas = header.querySelectorAll('.js-toggle-area')
  const bubbles = header.querySelectorAll('.js-toggle-bubble')

  const keywordSearchArea = Array.from(areas).find((area: HTMLElement) => {
    return area.dataset.toggleArea === 'keyword-search'
  })
  const keywordSearchInput: HTMLElement = keywordSearchArea.querySelector(
    '.js-keyword-search-input'
  )

  areaOpeners.forEach(areaOpener => {
    areaOpener.addEventListener('click', event => {
      const targetArea = (event.target as HTMLElement).dataset.targetArea

      areas.forEach((area: HTMLElement) => {
        targetArea === area.dataset.toggleArea
          ? area.classList.toggle('js-close')
          : area.classList.add('js-close')
      })

      bubbles.forEach((bubble: HTMLElement) => {
        targetArea === bubble.dataset.toggleBubble
          ? bubble.classList.toggle('js-close')
          : bubble.classList.add('js-close')
      })

      keywordSearchArea.classList.contains('js-close')
        ? keywordSearchInput.blur()
        : keywordSearchInput.focus()
    })
  })

  areaClosers.forEach(areaCloser => {
    areaCloser.addEventListener('click', () => {
      areas.forEach(area => area.classList.add('js-close'))
      bubbles.forEach(bubble => bubble.classList.add('js-close'))
    })
  })
})
